export var TEXT_TRACK_TEXT_CLASSNAME="ds-text-track__text";